import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import ValueInput from './ValueInput';
import UniqueValueChooser from './UniqueValueChooser';
import DomainValueChooser from './DomainValueChooser';
import RelativeDateChooser from './RelativeDateChooser';
import FieldNames from '../../../defaults/FieldNames.json';
import { getGenericFieldType } from '../utils/genericUtils';

export default function FieldValueChooser({expressionDef, isDropdownLoading, handleValueChanged, getCustomCodedValues, datasetSelection}) {
  const { valueType } = expressionDef;
  const operatorInternal = expressionDef.operator;
  const valueInternal = expressionDef.value
  const fieldInternal = expressionDef.field;
  const [codedValues, setCodedValues] = useState([]);
  const [singleVal, setSingleVal] = useState("")
  const tempType = fieldInternal?.type ? fieldInternal?.type : 'esriFieldTypeString';

  useEffect(() => {
    //Adding datasetSelection to trigger a refresh of the values in the dropdowns
    async function getOptions(){
      let tempCodedValues = await getCodedValues();
      setCodedValues(tempCodedValues?.length ? tempCodedValues : [])
      if(tempCodedValues?.length){
        setSingleVal(tempCodedValues[0])
      } else {
        setSingleVal('')
      }
      
    }
    getOptions();
  }, [expressionDef, datasetSelection])

  const getCodedValues = async() => {
    if ((fieldInternal && fieldInternal.domain && fieldInternal.domain.codedValues) || (fieldInternal && fieldInternal.domain === "custom")) {
      let tempCodedValues = [];
      if(fieldInternal.domain === "custom"){
        if(fieldInternal.name === "CongressionalDistrictNumber")
        {
          tempCodedValues = await getCustomCodedValues(fieldInternal.name)
        }
        else if(fieldInternal.modelName === "HideNational" || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingDepartment || 
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingAgency || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingRegion ||
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingUnit || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingSubUnit || 
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingTribe || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingUnitType || 
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.fundingSource || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.county ||
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.status || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.wbsID ||
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.type || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.category ||
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.class || fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.state || 
          fieldInternal.modelName === FieldNames.filterNamesWithCustomSetting.name
        )
        {
          tempCodedValues = await getCustomCodedValues(fieldInternal.modelName)
        } 
      } else {
        tempCodedValues = fieldInternal.domain.codedValues;
      }
      return tempCodedValues
    }
  }
    
  return (
    <>
      {(operatorInternal?.omitValue) && 
        <span></span>
      }
      {(!operatorInternal?.omitValue && valueType === 'unique') && 
        <UniqueValueChooser />
      }
      {(!operatorInternal?.omitValue && operatorInternal?.relativeDate) &&
        <RelativeDateChooser selectedValue={valueInternal ? valueInternal : ''} onChange={(event) => {handleValueChanged(event)}} />
      }
      {(!operatorInternal?.omitValue && ((fieldInternal?.domain?.codedValues?.length || fieldInternal?.domain === "custom") && 
      (fieldInternal?.modelName !== FieldNames.filterNamesWithCustomSetting.name || 
        (fieldInternal?.modelName === FieldNames.filterNamesWithCustomSetting.name && (operatorInternal?.alias === "is" || operatorInternal?.alias === "is not" ))))) && 
        <>
          {(isDropdownLoading && !getCodedValues()?.length) ? (<CircularProgress size={30} />) : (
            <DomainValueChooser
              codedValues={codedValues}
              selectedValue={valueInternal ? valueInternal : (singleVal ? singleVal : '')}
              onChange={(event) => handleValueChanged(event)}
            />)
          }
        </>
      }
      
      {(!operatorInternal?.omitValue && ((fieldInternal?.domain !== "custom" && !fieldInternal?.domain?.codedValues.length && 
      fieldInternal?.modelName !== FieldNames.filterNamesWithCustomSetting.name) ||
        (fieldInternal?.modelName === FieldNames.filterNamesWithCustomSetting.name && (operatorInternal.alias !== "is" && operatorInternal.alias !== "is not" )))) &&
        <ValueInput
        value={valueInternal?.code ? valueInternal.code : (valueInternal ? valueInternal : '')}
        type={getGenericFieldType(tempType)}
        onChange={handleValueChanged}
      />
      }
    </>
  );
}